export class ContractSlice {
    id?: string;
    contractId?: string;
    index?: number;
    price?: number;
    priceIndex?: number;
    tonnage?: number;
    isLastSlice?: boolean;
    constructor(contractSlice?: ContractSlice) {
        this.id = contractSlice?.id;
        this.contractId = contractSlice?.contractId;
        this.index = contractSlice?.index;
        this.price = contractSlice?.price;
        this.tonnage = contractSlice?.tonnage;
        this.isLastSlice = contractSlice?.isLastSlice;
        this.priceIndex = (contractSlice?.price || 1) * (contractSlice?.index || 1);
    }
}
